import {type CollectionId} from '@src/types/dataCollections.ts';
import {generatePath} from 'react-router';

export enum ANALYZE_ROUTE_KEYS {
  START = '',
  BROWSE = 'browse',
  VISUALIZE = 'visualize',
  EFFECTS = 'effects',
}

export const DATA_ROOT_ROUTE = 'data';
export const ANALYZE_ROOT_ROUTE = 'analyze/visual-analysis';
export const ANALYZE_RESTORE_PARAM = 'restore-default';

export const isAnalyzeBuild = import.meta.env.VITE_BUILD_ANALYZE === 'true';
export const ANALYZE_PATH_PREFIX = isAnalyzeBuild
  ? ''
  : `/${ANALYZE_ROOT_ROUTE}`;
export const ANALYZE_VISUALIZE_ROUTE = `${ANALYZE_PATH_PREFIX}/${ANALYZE_ROUTE_KEYS.VISUALIZE}`;

export const DataCollectionsRoutePattern = {
  root: '/collections',
  collection: {
    detail: '/collections/:collectionId',
    configurations: '/collections/:collectionId/configurations',
    tiles: '/collections/:collectionId/tiles',
    arrays: '/collections/:collectionId/arrays',
  },
  new: '/collections/new',
} as const;

export const DATA_COLLECTION_ROUTES = {
  root: DataCollectionsRoutePattern.root,
  collection: {
    detail: (collectionId: CollectionId) =>
      generatePath(DataCollectionsRoutePattern.collection.detail, {
        collectionId,
      }),
    configurations: (collectionId: CollectionId) =>
      generatePath(DataCollectionsRoutePattern.collection.configurations, {
        collectionId,
      }),
    tiles: (collectionId: CollectionId) =>
      generatePath(DataCollectionsRoutePattern.collection.tiles, {
        collectionId,
      }),
    arrays: (collectionId: CollectionId) =>
      generatePath(DataCollectionsRoutePattern.collection.arrays, {
        collectionId,
      }),
  },
  new: DataCollectionsRoutePattern.new,
};
